import { defineComponent as _defineComponent } from 'vue'
import { BookIntervalCode } from "@/types";
import useCurrencyFormat from "@/use/useCurrencyFormat";
import { PropType, computed } from "vue";


const __default__ = {
  name: "PaymentInfoWithoutSeats",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookingDatesCount: {
    type: Number,
    default: 0,
  },
  oneTimeFare: {
    type: Number,
  },
  currentBookInterval: {
    type: String as PropType<BookIntervalCode>,
  },
  totalAmount: {
    type: Number,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const getOneTimeFareStr = computed(() =>
  props.currentBookInterval === BookIntervalCode.MONTH
    ? "월예약 요금"
    : "1일 요금"
);

const __returned__ = { props, getOneTimeFareStr, get useCurrencyFormat() { return useCurrencyFormat } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})